import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import SupplementaryKnowledgeEditPage from './SupplementaryKnowledgeEditPage';
import { tiny } from '../../../store/actions/contracts';
import { setV2 } from '../../../store/actions/pagesV2';
import { uploadSuppKbDocument, createSupplementaryDocument } from '../../../store/api/supplementaryKnowledge';

const mapStateToProps = (state) => ({
    tinyContracts: state.contracts.tiny || [],
    uploadPending: false,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({
        getTinyContracts: tiny,
        resetSelectedContracts: () => setV2('contractsv2-landing', 'selected', []),
        setSelectedContracts: (item) => setV2('contractsv2-landing', 'selected', item),
        uploadDocument: (payload, callback) => async (dispatch) => {
            try {
                // Upload document - backend now returns s3_key in response
                const uploadResponse = await uploadSuppKbDocument(payload);
                
                // Extract data from FormData for second API call
                const contractIds = payload.getAll('ContractIds').map(id => parseInt(id));
                const documentName = payload.get('DocumentName');
                const file = payload.get('Document');
                
                // Extract s3_key from upload response (backend now provides it)
                // Handle multiple possible response structures
                const s3Key = uploadResponse?.s3_key || 
                              uploadResponse?.s3Key || 
                              uploadResponse?.documentMetadata?.s3_key ||
                              uploadResponse?.documentMetadata?.s3Key ||
                              '';

                // Second API call - create supplementary document in AI API
                const aiPayload = {
                    s3_key: s3Key,
                    filename: documentName,
                    contract_ids: contractIds,
                    document_id: uploadResponse.documentMetadataId,
                    metadata: { type: file?.type || 'application/pdf' },
                    description: uploadResponse?.documentMetadata?.description,
                };
                
                const aiResponse = await createSupplementaryDocument(aiPayload);
                
                // Call callback after both APIs succeed
                callback();
            } catch (error) {
                console.error('Upload failed:', error);
                throw error;
            }
        }
    }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(SupplementaryKnowledgeEditPage)));
